<template>
  <div class="bulletin">
    <div class="bulletin-title padding-30">
      <span
        @click="handleChange(item.key)"
        v-for="item in titles"
        :key="item.key"
        :class="{ 'bulletin-title-active': item.key === activite }"
      >
        {{ item.title }}
      </span>
    </div>
    <div class="bulletin-main">
      <JoLoadMore :showBottom="false" ref="loadmore" @onRefresh="onRefresh">
        <div class="bulletin-content">
          <div class="padding-30" v-show="showAnswerCard">
            <template v-for="question in questionList">
              <AnswerCard
                :question="question"
                :key="question.id"
                :type="answerType"
                class="answer-card"
              />
            </template>
          </div>
          <div class="feed-list" v-show="showFeed">
            <template v-for="feed in feedList">
              <FeedCard
                :key="feed.id"
                class="feed-card"
                :feed="feed"
                :excellent="!!feed.excellent_at"
              />
            </template>
          </div>
          <div class="group-list padding-30" v-show="showGroup">
            <template v-for="group in activeGroup">
              <GroupItem
                :key="group.id"
                class="group-item "
                :show-index="false"
                :group="group"
                :show-action="true"
              />
            </template>
          </div>
        </div>
        <div
          v-if="!loading"
          @click.stop="handleClickMore"
          class="bulletin-more padding-30"
        >
          >> 查看更多
        </div>
        <slot name="footer"></slot>
      </JoLoadMore>
    </div>
  </div>
</template>

<script>
import AnswerCard from "@/components/AnswerCard.vue";
import FeedCard from "@/components/FeedCard/FeedCard.vue";
import GroupItem from "@/components/GroupItem.vue";
import {
  getPlusGroup,
  getQuestions,
  getFeeds,
  getQuestionsAnswer
} from "@/api/bulletin";
export default {
  components: {
    AnswerCard,
    FeedCard,
    GroupItem
  },
  data() {
    return {
      activite: "invite",
      activeGroup: [],
      questionList: [],
      feedList: [],
      loading: false
    };
  },
  mounted() {
    this.handleChange(this.activite);
  },
  activated() {
    if (
      !this.activeGroup.length &&
      !this.feedList.length &&
      !this.questionList.length
    ) {
      this.handleChange(this.activite);
    }
  },
  computed: {
    titles() {
      return [
        { key: "invite", title: this.$t("profile.bulletin.invite_answer") },
        { key: "new_answer", title: this.$t("profile.bulletin.new_answer") },
        { key: "new_feed", title: this.$t("profile.bulletin.new_feed") },
        { key: "active_group", title: this.$t("profile.bulletin.active_group") }
      ];
    },
    showAnswerCard() {
      return ["invite", "new_answer"].indexOf(this.activite) > -1;
    },
    showFeed() {
      return ["new_feed"].indexOf(this.activite) > -1;
    },
    showGroup() {
      return ["active_group"].indexOf(this.activite) > -1;
    },
    answerType() {
      return this.activite;
    }
  },
  methods: {
    async handleChange(type) {
      this.activite = type;
      this.$refs.loadmore.beforeRefresh();
    },
    handleClickMore() {
      if (this.activite == "new_answer") {
        return this.$router.push({
          path: "/question?type=new"
        });
      }
      if (this.activite == "invite") {
        return this.$router.push({
          path: "/question?type=invite"
        });
      }
      if (this.activite == "active_group") {
        return this.$router.push({
          path: "/groups?category=all"
        });
      }
      if (this.activite == "new_feed") {
        return this.$router.push({
          path: "/shares"
        });
      }
    },
    async onRefresh() {
      this.loading = true;
      if (this.activite === "active_group") {
        await this.getActiveGroup();
      }
      if (this.activite === "invite") {
        await this.getQuestion("invite");
      }
      if (this.activite === "new_answer") {
        await this.getAnswer("new");
      }
      if (this.activite === "new_feed") {
        await this.getFeeds();
      }
      this.loading = false;
      this.$refs.loadmore.afterRefresh(true);
    },
    async getQuestion(type) {
      try {
        const { data } = await getQuestions({
          limit: 3,
          offset: 0,
          type
        });
        this.questionList = data;
      } catch (error) {
        this.questionList = [];
      }
    },
    async getAnswer() {
      try {
        const { data } = await getQuestionsAnswer({
          limit: 3,
          offset: 0
        });
        console.log(data);
        this.questionList = data;
      } catch (error) {
        console.log(error);
        this.questionList = [];
      }
    },
    async getActiveGroup() {
      try {
        const { data } = await getPlusGroup({
          category_id: 0,
          limit: 3,
          offset: 0,
          new: 1
        });
        this.activeGroup = data;
      } catch (error) {
        this.activeGroup = [];
      }
    },
    async getFeeds() {
      try {
        const { data } = await getFeeds({
          limit: 3,
          offset: 0,
          type: "new"
        });
        this.feedList = data.feeds.map(item => {
          const { attachments, ...others } = item;
          return others;
        });
      } catch (error) {
        this.feedList = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
@blueColor: #3283a2;
.bulletin {
  margin-top: 44px;
  .padding-30 {
    padding: 0 30px;
  }
  .bulletin-title {
    display: flex;
    font-size: 28px;
    color: #666666;
    justify-content: space-between;
    &-active {
      color: @blueColor;
    }
  }
  .answer-card {
    padding-bottom: 36px;
    margin-bottom: 36px;
    border-bottom: 1px solid #dbdbdb;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .bulletin-more {
    color: @blueColor;
    text-align: right;
    font-size: 26px;
    position: relative;
    z-index: 1;
    padding-top: 25px;
  }
  .feed-list {
    padding-bottom: 20px;
    background-color: #f7f7f7;
    .feed-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      ::v-deep .m-card-con {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        word-break: break-all;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
      }
      ::v-deep .m-tags {
        margin-left: 0;
      }
    }
  }
  .bulletin-main {
    overflow: hidden;
    margin-top: 40px;
    overflow: hidden;
    min-height: 600px;
  }
  .group-list {
    .group-item {
      padding-left: 0;
      padding-right: 0;
      border-bottom: 1px solid #dbdbdb;
    }
  }
}
</style>
